import React, { useEffect, useState } from "react";

// import i1 from '../Assets/newservices/Digital Marketing.jpeg';
import i1 from '../Assets/newservices/Website Design & Development.jpeg';
import i2 from '../Assets/newservices/Performance Marketing.jpeg';
import i3 from '../Assets/newservices/Website Management.jpeg';

const data = [
  // {
  //   title: "Digital Marketing",
  //   img: i1,
  // },
  {
    title: "Website Design & Development",
    img: i1,
  },
  {
    title: "Performance Marketing",
    img: i2,
  },
  {
    title: "Website Management",
    img: i3,
  },
];

const Industries = () => {
  const [active, setActive] = useState(0);

  // Infinite auto change
  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % data.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  // helper for circular index
  const getIndex = (i) => {
    const len = data.length;
    return (i - active + len) % len;
  };

  return (
    <section className="w-full bg-gray-100 py-16 overflow-hidden">
      
      {/* Heading */}
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-[#f99728]">
          TOP INDUSTRIES WE SERVE
        </h2>
      </div>

      {/* 3D Wrapper */}
      <div className="relative flex justify-center items-center h-[350px] perspective">

        {data.map((item, index) => {
          const position = getIndex(index);

          return (
            <div
              key={index}
              className={`absolute transition-all duration-700 ease-in-out
                ${position === 0 && "center"}
                ${position === 1 && "right"}
                ${position === 2 && "left"}
              `}
            >
              <div className="card">
                <img src={item.img} alt="" />
                {/* <div className="overlay">
                  <h3>{item.title}</h3>
                </div> */}
              </div>
            </div>
          );
        })}

      </div>
    </section>
  );
};

export default Industries;